
<template>
  <div id="footer">
    <ul>
      <li>
        <a href="https://www.facebook.com/Chicago-River-Canoe-Kayak-179885055397961/">
          <img src="../assets/fblogo.png" alt="">
        </a>
      </li>
      <li>
        <a href="https://www.instagram.com/chicagoriverpaddle/">
          <img src="../assets/insta.png" alt="">
        </a>
      </li>
      <li>
        <a href="https://twitter.com/ChiCanoeKayak/">
          <i class="fab fa-twitter"></i>
        </a>
      </li>
      <li class="email-text">
        <a class="white" href="mailto:info@chicagoriverpaddle.com">
          info@ChicagoRiverPaddle.com
        </a>
      </li>
    </ul>
    
    <a href="https://www.imejtech.com/#/">
      Website by:  IMEJ Tech
    </a>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  display: table-row;
  margin-bottom: 0;
}

li {
  margin-right: 20px;
  padding: 10px;
  display: table-cell;
  vertical-align: middle;
}

#footer {
  border-top: 5px solid #c0504d;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 100px;
}

img {
  width: 36px;
}

i.fab {
  font-size: 36px;
}

.footer {
  background-image: url("../assets/pic9.png");
}

.email-text a {
  color: white;
}
.email-text a:hover {
  color: #c0504d;
}

@media screen and (max-width: 768px) {
  .email-text a {
    width: 90%;
    font-size: 12px;
    padding-right: 0;
  }
  #footer {
    flex-direction: column;
  }
  img {
    width: 20px;
  }
  i.fab {
    font-size: 24px;
  }
}


</style>









